import { useEffect, useState } from "react";
import Seo from "../components/Seo.jsx"
import Nav from '../components/Nav.jsx'
import Header from '../components/header.jsx'
import About from '../components/about.jsx'
import Team from '../components/team.jsx'
import ContactUs from '../components/form.jsx'
import Footer from '../components/footer.jsx'
import PropertyShowcaseList, { sortPropertyShowcases } from '../features/propertyShowcaseList.jsx'
import { listProperties } from "../admin/properties.js"
import { fetchImagesByPath } from "../features/photos.jsx"
import {
  DEFAULT_DESCRIPTION,
  DEFAULT_KEYWORDS,
  DEFAULT_TITLE,
  buildOrganizationStructuredData,
  buildWebsiteStructuredData,
} from "../seo.js"

const HOME_TRUST_POINTS = [
  { label: "Locally Managed", value: "In-house service" },
  { label: "Service Area", value: "Halifax & Wolfville" },
  { label: "Direct Contact", value: "Fast inquiries" },
];

function Home(){
    const [displayedUnitCount, setDisplayedUnitCount] = useState(0);
    const [propertiesLoading, setPropertiesLoading] = useState(true);
    const [propertyShowcases, setPropertyShowcases] = useState([]);
    const [unitCountTarget, setUnitCountTarget] = useState(0);

    useEffect(() => {
      let isMounted = true;

      async function loadHomepageProperties() {
        try {
          const properties = sortPropertyShowcases(await listProperties());
          const totalUnits = properties.reduce(
            (sum, property) => sum + property.units.length,
            0
          );
          const baseProperties = properties.map((property) => ({
            ...property,
            images: [],
          }));

          if (isMounted) {
            setPropertyShowcases(baseProperties);
            setUnitCountTarget(totalUnits);
            setPropertiesLoading(false);
          }

          await Promise.allSettled(
            properties.map(async (property) => {
              const images = await fetchImagesByPath(property.documentPath);

              if (!isMounted) {
                return;
              }

              setPropertyShowcases((currentProperties) =>
                currentProperties.map((currentProperty) =>
                  currentProperty.id === property.id
                    ? {
                        ...currentProperty,
                        images,
                      }
                    : currentProperty
                )
              );
            })
          );
        } catch (error) {
          if (isMounted) {
            setPropertyShowcases([]);
            setUnitCountTarget(0);
            setPropertiesLoading(false);
          }
        }
      }

      loadHomepageProperties();

      return () => {
        isMounted = false;
      };
    }, []);

    useEffect(() => {
      let animationFrameId = 0;
      const duration = 900;
      const startTime = performance.now();

      function animate(currentTime) {
        const progress = Math.min((currentTime - startTime) / duration, 1);
        const nextValue = Math.round(unitCountTarget * progress);

        setDisplayedUnitCount(nextValue);

        if (progress < 1) {
          animationFrameId = window.requestAnimationFrame(animate);
        }
      }

      setDisplayedUnitCount(0);
      animationFrameId = window.requestAnimationFrame(animate);

      return () => {
        window.cancelAnimationFrame(animationFrameId);
      };
    }, [unitCountTarget]);

    const homepageSeo = (
      <Seo
        description={DEFAULT_DESCRIPTION}
        keywords={DEFAULT_KEYWORDS}
        pathname="/"
        structuredData={[buildOrganizationStructuredData(), buildWebsiteStructuredData()]}
        title={DEFAULT_TITLE}
      />
    );

    return(

<div className="home-page">
    {homepageSeo}

     
    <div><Nav/></div>
    <div><Header/></div>
    <section className="home-trust-strip" aria-label="Pentagon Properties highlights">
      <div className="home-trust-strip__inner">
        <article className="home-trust-strip__card" key="units-listed">
          <p className="home-trust-strip__label">Units Listed</p>
          <h2 className="home-trust-strip__value">{displayedUnitCount}</h2>
        </article>
        {HOME_TRUST_POINTS.map((point) => (
          <article className="home-trust-strip__card" key={point.label}>
            <p className="home-trust-strip__label">{point.label}</p>
            <h2 className="home-trust-strip__value">{point.value}</h2>
          </article>
        ))}
      </div>
    </section>
    <div className="home-band home-band--showcase">
      <PropertyShowcaseList loading={propertiesLoading} properties={propertyShowcases}/>
    </div>
    <div className="home-band home-band--about"><About/></div>
    <div className="home-band home-band--team"><Team/></div>
      <div className="home-band home-band--contact"><ContactUs/></div>
      <div><Footer/></div>

    </div>

    )
};
export default Home
